import React from "react";

/**
 * Simple wrapper to apply consistent vertical spacing between form elements.
 */
export default function FormGroup({ children, className = "" }) {
  return <div className={`mb-4 ${className}`}>{children}</div>;
}
